var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcContent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10623_106375)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10623_106375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9978 21.8H13.1177C12.2903 21.7986 11.4973 21.4689 10.9128 20.8834C10.3283 20.2979 10 19.5043 10 18.677V11.1177C10.0014 10.2913 10.3303 9.49908 10.9147 8.91471C11.4991 8.33033 12.2913 8.00141 13.1177 8H26.9978C27.8237 8.00141 28.6153 8.33051 29.1988 8.91503C29.7824 9.49956 30.1101 10.2917 30.1101 11.1177V18.677C30.1108 19.0864 30.0309 19.492 29.8748 19.8705C29.7188 20.249 29.4897 20.5931 29.2007 20.8831C28.9117 21.1731 28.5684 21.4033 28.1904 21.5606C27.8124 21.718 27.4072 21.7993 26.9978 21.8ZM13.1177 9.17447C12.6023 9.17447 12.108 9.3792 11.7436 9.74362C11.3792 10.108 11.1745 10.6023 11.1745 11.1177V18.677C11.1745 19.1924 11.3792 19.6866 11.7436 20.051C12.108 20.4155 12.6023 20.6202 13.1177 20.6202H26.9978C27.5122 20.6188 28.0051 20.4134 28.3684 20.0492C28.7316 19.6849 28.9356 19.1914 28.9356 18.677V11.1177C28.9356 10.6032 28.7316 10.1098 28.3684 9.74551C28.0051 9.38124 27.5122 9.17588 26.9978 9.17447H13.1177Z",
    fill: "#B1B5C6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10623_106375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10623_106375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.1101,
    height: 13.8,
    fill: "white",
    transform: "translate(10 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContent);
export default __webpack_public_path__ + "static/media/ic_content.41618bd4ec6aa2c34aed8701bd2abedd.svg";
export { ForwardRef as ReactComponent };